import * as angular from "angular";
import { HouseOccupant } from "../models/house-occupant.model";
import { DuplicatesService } from "../services/duplicates.service";

export class DuplicatesDataProvider {
    private service: DuplicatesService;
    private $q: any;

    constructor($q: any, DuplicatesService: DuplicatesService) {
        this.$q = $q;
        this.service = DuplicatesService;
    }
    all(): Promise<any> {
        const deferred = this.$q.defer();

        this.service.all().then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }

    merge(
        primaryHouseOccupant: HouseOccupant,
        secondaryHouseOccupant: HouseOccupant
    ): Promise<any> {
        const deferred = this.$q.defer();

        this.service
            .merge({
                primaryHoid: primaryHouseOccupant.hoid,
                secondaryHoid: secondaryHouseOccupant.hoid,
            })
            .then(
                (response: object) => {
                    const json = response["data"];
                    if (json.success) {
                        deferred.resolve(json.data);
                    } else {
                        deferred.reject(json);
                    }
                },
                (error: object) => deferred.reject(error)
            );
        return deferred.promise;
    }

    update(duplicate: object): Promise<any> {
        const deferred = this.$q.defer();

        this.service.update(duplicate).then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );
        return deferred.promise;
    }

    latest(): Promise<any> {
        const deferred = this.$q.defer();

        this.service.latest().then(
            (response: object) => {
                const json = response["data"];
                if (json.success) {
                    deferred.resolve(json.data);
                } else {
                    deferred.reject(json);
                }
            },
            (error: object) => deferred.reject(error)
        );

        return deferred.promise;
    }
}

angular
    .module("vcDataProvider")
    .service("DuplicatesDataProvider", DuplicatesDataProvider);
